import router from '@/router/index'
import store from '@/store/index'
import { getToken } from '@/utils/auth'

const ROUTE_HOME = 'app'
const ROUTE_LOGIN = 'auth.login'
const ROUTE_REGISTER = 'auth.register'

const AUTH_ROUTES = [ROUTE_LOGIN, ROUTE_REGISTER]

function nextRoute(to, next) {
    if (AUTH_ROUTES.includes(to.name)) {
        next({ name: ROUTE_HOME })
    } else {
        next()
    }
}

router.beforeEach(async (to, from, next) => {
    const token = getToken()
    const authenticated = store.getters['user/authenticated']

    if (!token) {
        // if (!AUTH_ROUTES.includes(to.name)) {
        //     next({ name: ROUTE_LOGIN })
        // } else {
        //     next()
        // }
        next()
    } else if (!authenticated) {
        try {
            await store.dispatch('user/fresh')

            if (AUTH_ROUTES.includes(to.name)) {
                next({ name: ROUTE_HOME })
            } else {
                next()
            }
        } catch {
            next({ name: ROUTE_LOGIN })
        }
    } else {
        nextRoute(to, next)
    }
})
